import axios from "axios";

const API = axios.create({
  baseURL: "/api", // Prilagodi ako koristiš drugi port
  //baseURL:"http://13.49.132.47:3002",
  headers: {
    "Content-Type": "application/json",
  },
});

// Automatski dodaj token u svaki request ako postoji
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
